import fetch from '../utils/fetch'

//發票列表
export function invoiceList (query) {
  return fetch({
    url: `/invoice/orders`,
    method: 'get',
    params: query

  })
}


//發票詳情
export function invoiceDetail (oriderId) {
  return fetch({
    url: `/invoice/order/detail?order_id=${oriderId}`,
    method: 'get',
  })
}

export function orderInvoiceExport(query) {
  return fetch({
    url: '/invoice/exportdataNew',
    method: 'get',
    params: query
  })
}
